import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  gridItem: {
    maxHeight: 520,
  },
  isLoading: {
    height: 520,
  },
}))
